import { PostEditorPostError, PostEditorPostErrors, PostGroupsType } from '../../../models/post-editor';
import { ErrorMessageSeverity } from '../../../constants/form';
import { PostTiming } from '../../../models/graphql';
import { severityResolver } from './helpers/severity-resolver';
import { PostEditorValidationMessages } from '../constants/validation-messages';

export const checkRecurringInterval = (
  postGroup: PostGroupsType,
  severity: ErrorMessageSeverity
): PostEditorPostErrors => {
  const { groupPostAttributes, customizeSchedulePerProfile, posts } = postGroup;
  let results: PostEditorPostError[] = [];
  if (customizeSchedulePerProfile) {
    posts.forEach(post => {
      const { postTiming, recurring, recurringValue } = post.scheduling;
      const isRecurring = postTiming === PostTiming.RECURRING && recurring.active;
      if (isRecurring && (!recurringValue || recurringValue < 1 || recurringValue > 500)) {
        results = [
          ...results,
          {
            profileId: post.customizedProfileId,
            variationId: null,
            severity: severityResolver(post, severity),
            selectedSocialProfiles: [],
            message: PostEditorValidationMessages.schedule.recurringInterval
          }
        ];
      }
    });
    return results.length ? results : false;
  } else {
    const { postTiming, recurring, recurringValue } = groupPostAttributes.scheduling;
    return postTiming === PostTiming.RECURRING &&
      recurring.active &&
      (!recurringValue || recurringValue < 1 || recurringValue > 500)
      ? {
          profileId: null,
          variationId: null,
          severity: severityResolver(groupPostAttributes, severity),
          selectedSocialProfiles: [],
          message: PostEditorValidationMessages.schedule.recurringInterval
        }
      : false;
  }
};
